export const environment = {
  production: true,
  env: 'prod',
  recaptcha: '6Lf_6jsqAAAAAKMWf0BNO7qTD0HpWcy0m6w6D1kZ',
  api_v1_url: 'https://public-api.snapmatic.me',
  api_v2_url: 'https://sapi-v2.snapmatic.me',
  assets_url: 'https://uploads.snapmatic.me/',
  ws_url: 'wss://ws.snapmatic.me/',
  // Client branch (French build): sentry_environment is the client name.
  sentry_dsn: 'https://c0e3871c46d8c2d7c9776558029b2e9c@sentry.analog-robot.com/5',
  sentry_environment: 'will-power-fr',
  distribution: { // make sure numbers add up to 100
    "awaiting": 0,
    "update_input_completed": 0,
    "fetched": 1,
    "running_detection": 4,
    "detection_completed": 7,
    "training": 10,
    "generation": 74,
    "uploading": 3,
    "complete": 1,
  },
  stages: {
    "awaiting": "Analyse de l’unicité",
    "update_input_completed": "Analyse de l’unicité",
    "fetched": "Attribution d’un créneau de traitement IA",
    "running_detection": "Analyse de l’unicité",
    "detection_completed": "Attribution d’un créneau de traitement IA",
    "training": [
      "training ai",
      "Calcul des poses",
      "Détection des traits",
      "Application de la physiognomonie",
      "Lecture des micro-expressions faciales"
    ],
    "generation": [
      "calculating uniqueness",
      "Calcul des poses",
      "Détection des traits",
      "Application de la physiognomonie",
      "Lecture des micro-expressions faciales",
      "Application de la créativité"
    ],
    "uploading": "Préparation des résultats",
    "complete": "Terminé",
    "generation_error": "Erreur de génération"
  }
};
